import { notFound } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { helpSearch } from "../../src/lib/help-navigation";
import { siteContext } from "../server/site.server";
import { helpArticle, helpIndex } from "./help.server";
import { platformPageResponse } from "./page-response";

function input(value: unknown) {
  if (!value || typeof value !== "object") throw notFound();
  const data = value as Record<string, unknown>;
  const slug = data.slug;
  if (slug !== undefined && (typeof slug !== "string" || !/^[a-z0-9-]{1,120}$/.test(slug)))
    throw notFound();
  const search = helpSearch(data);
  return {
    q: search.q ?? "",
    audience: search.audience ?? ("creators" as const),
    slug: slug as string | undefined,
  };
}

/** Public Drate support only. Creator sites retain their own content and authorization. */
export const loadHelpIndex = createServerFn({ method: "GET" })
  .validator(input)
  .handler(async ({ data, context }) => {
    const drate = await siteContext(context);
    if (drate.creator) return null;
    platformPageResponse(drate);
    return helpIndex(data.audience, data.q, data.slug);
  });

export const loadHelpArticle = createServerFn({ method: "GET" })
  .validator(input)
  .handler(async ({ data, context }) => {
    const drate = await siteContext(context);
    if (drate.creator || !data.slug) return null;
    platformPageResponse(drate);
    return helpArticle(data.slug, data.audience);
  });
